import getAnyOrNull from 'utils/accessors/getAnyOrNull.util';
import nullBind from 'utils/functions/nullBind.util';

export const selectCookieChoice = nullBind(getAnyOrNull, 'cookies.cookieChoice');
export const selectTrackingStatus = nullBind(getAnyOrNull, 'cookies.tracking');
